// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f05c6576","455":"4bb2f058"}[chunkId] + ".chunk.js";
};